export enum TipoExemplo {
  POSITIVO = <any> 'POSITIVO',
  NEGATIVO = <any> 'NEGATIVO'
}
